import { z } from "zod";

const baseInsuranceInformationSchema = z.object({
  hasSupplementaryPolicy: z.enum(["yes", "no"], {
    required_error: "Please select an option",
  }),
  dailyInsulinDose: z.string().optional(),
});

export const supplementaryPolicySchema = baseInsuranceInformationSchema.extend({
  hasSupplementaryPolicy: z.literal("yes"),
  supplementaryPolicyName: z
    .string()
    .min(1, { message: "Policy name is required" }),
  supplementaryPolicyNumber: z
    .string()
    .min(1, { message: "Policy number is required" }),
  coInsurancePercentage: z
    .string()
    .min(1, { message: "Co-insurance is required" }),
});

export const noSupplementaryPolicySchema =
  baseInsuranceInformationSchema.extend({
    hasSupplementaryPolicy: z.literal("no"),
  });

export type SupplementaryPolicyFormType = z.infer<
  typeof supplementaryPolicySchema
>;

export const insuranceInformationFormSchema = z.discriminatedUnion(
  "hasSupplementaryPolicy",
  [supplementaryPolicySchema, noSupplementaryPolicySchema],
);

export type InsuranceInformationFormType = z.infer<
  typeof insuranceInformationFormSchema
>;
